import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_BRAND_FAILURE,
  CREATE_BRAND_REQUEST,
  GET_ALL_BRAND_SUCCESS,
  GET_ALL_BRAND_REQUEST,
  GET_ALL_BRAND_FAILURE,
  DELETE_BRAND_REQUEST,
  DELETE_BRAND_FAILURE,
  UPDATE_BRAND_REQUEST,
  UPDATE_BRAND_FAILURE,
  DELETE_BRAND_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllBrand = () => async (dispatch) => {
  dispatch({ type: GET_ALL_BRAND_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/brands`);
    dispatch({ type: GET_ALL_BRAND_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_BRAND_FAILURE, payload: error.message });
  }
};

export const createBrand = (brandData) => async (dispatch) => {
  dispatch({ type: CREATE_BRAND_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/brand`, brandData);
    if (data.status === "SUCCESS") {
      dispatch(getAllBrand());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_BRAND_FAILURE, payload: error.message });
  }
};

export const updateBrand = (brandId, brandData) => async (dispatch) => {
  dispatch({ type: UPDATE_BRAND_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/brand/${brandId}`,
      brandData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllBrand());
      toast.success("Brand Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_BRAND_FAILURE, payload: error.message });
  }
};

export const deleteBrand = (brandId) => async (dispatch) => {
  dispatch({ type: DELETE_BRAND_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/brand/${brandId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_BRAND_SUCCESS, payload: brandId })
      dispatch(getAllBrand());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_BRAND_FAILURE, payload: error.message });
  }
};
